import React from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import About from "@/components/landing/About";
import Services from "@/components/landing/Services";
import Products from "@/components/landing/Products";
import WhyChooseUs from "@/components/landing/WhyChooseUs";
import TechStack from "@/components/landing/TechStack";
import Stats from "@/components/landing/Stats";
import Testimonials from "@/components/landing/Testimonials";
import AudioTestimonials from "@/components/landing/AudioTestimonials";
import YouTubeLibrary from "@/components/landing/YouTubeLibrary";
import FAQ from "@/components/landing/FAQ";
import Contact from "@/components/landing/Contact";
import CTA from "@/components/landing/CTA";
import Footer from "@/components/landing/Footer";
import TrustMarquee from "@/components/landing/TrustMarquee";
import ScrollProgress from "@/components/landing/effects/ScrollProgress";
import CursorGlow from "@/components/landing/effects/CursorGlow";
import GlobalDNA from "@/components/landing/effects/GlobalDNA";

const Landing = () => {
    return (
        <main data-testid="landing-page" className="relative bg-[#050505] text-white">
            <GlobalDNA />
            <ScrollProgress />
            <CursorGlow />
            <div className="relative z-10">
                <Header />
                <Hero />
                <TrustMarquee />
                <About />
                <Services />
                <Products />
                <WhyChooseUs />
                <TechStack />
                <Stats />
                <Testimonials />
                <AudioTestimonials />
                <YouTubeLibrary />
                <FAQ />
                <Contact />
                <CTA />
                <Footer />
            </div>
        </main>
    );
};

export default Landing;
